/**
 * Injection tokens that surface host-specific catalogs to the workflow
 * designer (entity schemas, email templates, trigger types). All default to
 * empty so the designer can run standalone; production hosts override them.
 */

import { InjectionToken, Signal, signal } from '@angular/core';
import { EmailTemplateSummary, WorkflowEntityCatalog } from '../models/entity-schema.model';

const EMPTY_CATALOG: WorkflowEntityCatalog = { entities: [], enums: [] };

export const WORKFLOW_ENTITY_CATALOG = new InjectionToken<Signal<WorkflowEntityCatalog>>(
  'WORKFLOW_ENTITY_CATALOG',
  { providedIn: 'root', factory: () => signal(EMPTY_CATALOG).asReadonly() }
);

export const WORKFLOW_EMAIL_TEMPLATES = new InjectionToken<Signal<EmailTemplateSummary[]>>(
  'WORKFLOW_EMAIL_TEMPLATES',
  { providedIn: 'root', factory: () => signal<EmailTemplateSummary[]>([]).asReadonly() }
);

export const WORKFLOW_TRIGGER_TYPES = new InjectionToken<Signal<string[]>>(
  'WORKFLOW_TRIGGER_TYPES',
  { providedIn: 'root', factory: () => signal<string[]>([]).asReadonly() }
);
